import * as React from "react";
import Row from "../../layout/Row";
import Col from "../../layout/Col";
import {Option} from "ts-option";
import PartnerBrandPointsFormGroup from "./points/PartnerBrandPointsFormGroup";
import PartnerBrandPoints from "../../../model/partnerBrand/PartnerBrandPoints";
import DatePickerFormGroup from "../../date/DatePickerFormGroup";
import RewardsStatusFormGroup from "./RewardsStatusFormGroup";
import PartnerBrandRewardsDataForm from "../../partnerBrand/PartnerBrandRewardsDataForm";
import {FormField} from "../../../validation/FormField";

interface ComponentProps {
	/**
	 * Partner brand ID.
	 */
	partnerBrandId: Option<string>
	/**
	 * On add points
	 * @param {PartnerBrandPoints} point
	 */
	onAddPoints: (point: PartnerBrandPoints) => void
	/**
	 * Newly added points
	 */
	points: PartnerBrandPoints[]
	/**
	 * Form containing partner brand reward related inputs.
	 */
	form: PartnerBrandRewardsDataForm;
	/**
	 * On change field value.
	 * @param field updated field.
	 */
	onFieldChange: (field: FormField<any>) => void;
	/**
	 * Total submitted PB rewards points.
	 */
	totalSubmittedPoints: number
	/**
	 * Total used PB rewards points.
	 */
	totalUsedPoints: number
	/**
	 * Total earned PB rewards points.
	 */
	totalEarnedPoints: number
	/**
	 * Total available PB rewards points.
	 */
	totalAvailablePoints: number;
}

export default class PartnerBrandRewardsDataFormBody extends React.PureComponent<ComponentProps, {}> {
	render() {
		return (
			<div className={"c-create-brand"}>
				<Row>
					<Col xl={4} md={4}>
						<DatePickerFormGroup label={"Sign up date"}
											 onChange={this.props.onFieldChange}
											 field={this.props.form.signUpDate}/>
					</Col>
					<Col xl={4} md={4}>
						<RewardsStatusFormGroup label={"Rewards status"}
												onChange={this.props.onFieldChange}
												field={this.props.form.status}/>
					</Col>
				</Row>
				<Row>
					<Col xl={12} md={12}>
						<PartnerBrandPointsFormGroup partnerBrandId={this.props.partnerBrandId}
													 onAddPoints={this.props.onAddPoints}
													 points={this.props.points}/>
					</Col>
				</Row>
				<Row>
					<Col xl={3} md={3}>
						<label className={"m-form-group_label"}>
							Total submitted reward points
						</label>
						<br/>
						<label className={"m-form-group_label"}>
							{this.props.totalSubmittedPoints.toString()}
						</label>
					</Col>
					<Col xl={3} md={3}>
						<label className={"m-form-group_label"}>
							Total used reward points
						</label>
						<br/>
						<label className={"m-form-group_label"}>
							{this.props.totalUsedPoints.toString()}
						</label>
					</Col>
					<Col xl={3} md={3}>
						<label className={"m-form-group_label"}>
							Total earned reward points
						</label>
						<br/>
						<label className={"m-form-group_label"}>
							{this.props.totalEarnedPoints.toString()}
						</label>
					</Col>
					<Col xl={3} md={3}>
						<label className={"m-form-group_label"}>
							Total available reward points
						</label>
						<br/>
						<label className={"m-form-group_label"}>
							{this.props.totalAvailablePoints.toString()}
						</label>
					</Col>
				</Row>
			</div>
		);
	}
}
